export const CONTAINER_ID = 'sports';
export const SPORTS_OVERLAYS_ID = 'sports-overlays';
export const SPORTSBOOK_CUSTOMIZATION_BUTTON_ID = 'sport-customization-button';
